const state = {
    recursosSelected: [],
    isSelected: false
} 

const getters = {
    getRecursosSelected: (state) => {
        return state.recursosSelected;
    },
    getIsSelected: (state) => {
        return state.isSelected;
    }
}

const mutations = {
    ONCHANGE_SELECTION(state, recursos){
        state.recursosSelected = recursos;
    },
    UPDATE_ISSELECTED(state, value){
        state.isSelected = value;
    }
}

const actions = {
    updateSelection({commit},recursos){
        commit('ONCHANGE_SELECTION',recursos);
    },
    isSelected({commit},recurso){
       
        commit('UPDATE_ISSELECTED',state.recursosSelected.some((_recurso) => recurso._id == _recurso._id))
    }
}

export const recursos = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}